/**
 * HTTP Client Error Classes
 */

export class FetchError extends Error {
  /** Optional structured metadata from the error response body (e.g. { quoteStatus }) */
  meta?: Record<string, unknown>;

  constructor(
    message: string,
    public status?: number,
    public statusText?: string,
    public url?: string,
    public method?: string,
  ) {
    super(message);
    this.name = "FetchError";
  }

  toString(): string {
    return `${this.name}: ${this.message} [${this.method} ${this.url}] - ${this.status} ${this.statusText}`;
  }
}

/**
 * A 404 is often a settled answer rather than a failure — "this resource does not exist
 * yet" is a state some views must render. Callers that treat it as data use this instead
 * of matching on `status` inline.
 */
export function isNotFound(error: unknown): boolean {
  return error instanceof FetchError && error.status === 404;
}
